import { Layout, Space, Typography } from 'antd';
import { appVersion } from 'configs/variables';

export default function Footer() {
  return (
    <Layout.Footer>
      <div className="gx-layout-footer-content">
        <div className="space-align-block">
          <Space size={3} style={{ justifyContent: 'space-between' }}>
            <span>
              Copyright © {`${new Date().getFullYear()}`}{' '}
              <img src="/img/oneforce-small-logo.png" alt="oneforce small logo" /> OneForce. All rights reserved.
            </span>

            <Typography.Text style={{ color: '#f5f5f5', opacity: 0.3 }}>{appVersion}</Typography.Text>
          </Space>
        </div>
      </div>
    </Layout.Footer>
  );
}
